import { render } from "./packadd.vue?vue&type=template&id=1fd4c20e"
import script from "./packadd.vue?vue&type=script&lang=js"
export * from "./packadd.vue?vue&type=script&lang=js"

import "./packadd.vue?vue&type=style&index=0&id=1fd4c20e&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__